import { render, staticRenderFns } from "./StudyQuestion.vue?vue&type=template&id=ea8062c8&scoped=true"
import script from "./StudyQuestion.vue?vue&type=script&lang=js"
export * from "./StudyQuestion.vue?vue&type=script&lang=js"
import style0 from "./StudyQuestion.vue?vue&type=style&index=0&id=ea8062c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8062c8",
  null
  
)

export default component.exports